/**
 * Created by lu on 2017/12/2.
 */
var nb = require('../nb');
// var util = require('../util');

var getCartList = require('../io/' + process.env.APP_ENV + '/cart/getCartList'); //购物车列表
var getSalesInfo = require('../io/' + process.env.APP_ENV + '/console/getSalesInfo');//销售信息

var CartListItem = nb.define({
    view: {
        tag: 'li',
        'class': 'header-cart-item',
        $html: [{
            tag: 'a',
            'class': 'pro-img',
            href: nb.bind('href'),
            target: '_blank',
            $html: {
                tag: 'img',
                alt: nb.bind('nameCn'),
                src: nb.bind('imgUrl')
            }
        }, {
            'class': 'pro-info',
            $html: [{
                tag: 'a',
                href: nb.bind('href'),
                target: '_blank',
                'class': 'pro-cn-name uk-text-truncate',
                title: nb.bind('nameCn'),
                $text: nb.bind('nameCn')
            }, {
                tag: 'a',
                href: nb.bind('href'),
                target: '_blank',
                'class': 'pro-cn-name uk-text-truncate',
                title: nb.bind('nameEn'),
                $text: nb.bind('nameEn')
            }, {
                'class': 'info-item',
                $html: [{
                    tag: 'span',
                    $text: nb.bind('numText')
                }, {
                    tag: 'span',
                    $text: nb.bind('count')
                }]
            }, {
                'class': 'info-item',
                $html: [{
                    tag: 'span',
                    $text: nb.bind('priceText')
                }, {
                    tag: 'span',
                    $text: nb.bind('disPrice')
                }]
            }]
        }]
    }
});
var CartListModel = nb.define({
    parent: require('../model/list/List'),
    method: {
        init: function () {
            this.setOpts({
                itemType: CartListItem
            });

            this.onChange('items', function (inEvent, inItems) { //status 2以询价
                $.each(inItems, function (inIndex, inItem) {
                    var status = inItem.get('status');
                    var isEffective = inItem.get('isEffective');
                    var inItemCode = inItem.get('itemCode');
                    inItem.set('href', 'productDetail.html?itemCode=' + encodeURI(inItemCode));
                    if (status === '2') {
                        if (isEffective === '1') {
                            inItem.set('disPrice', '￥' + inItem.get('sellingPrice'));
                        } else {
                            inItem.set('disPrice', '￥' + inItem.get('originPrice'));
                        }
                    } else {
                        inItem.set('disPrice', '￥' + inItem.get('originPrice'));
                    }
                });
            }, this);
        }
    }
});
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        cartList: CartListModel
    },
    method: {
        init: function () {
            var self = this;

            this.set('style', 'default'); //产品页header

            this.onChange('requireSwitchLanguage', function (inEvent) {
                var lan = nb.model.get('switchLanguage');
                if (lan === 'cn') {
                    lan = 'en';
                } else {
                    lan = 'cn';
                }
                $.cookie('b2b-language', lan);
                nb.model.set('switchLanguage', lan);
            }, this);

            nb.model.onChange(nb.model.user, function (inEvent, inUser) {

                inUser.onChange('loginReady', function (inEvent, inLoginReady) {
                    this.set('onlyWater',inUser.get('onlyWater'));
                    this._userId = parseInt(inUser.get('userId'));
                    this._companyId = parseInt(inUser.get('companyId')); //companyId
                    this._userState = inUser.get('userState'); //用户状态
                    this._checkCompleteInfo = inUser.get('checkCompleteInfo'); //用户状态

                    var loginReady = inLoginReady;
                    this.set('loginReady', loginReady);
                    if (loginReady) {
                        this.set('loginHref', 'console.html');
                        this.set('loginText', inUser.get('userName'));
                        this.set('cartHref', 'cart.html');
                        this._getCartList();


                        if (this._userState == '4' || this._userState == '5') {
                            this._getSalesInfo();
                        } else {
                            this.set('hasSale', 'hide');
                        }


                    } else {
                        this.set('loginHref', 'login.html');
                        this.set('cartHref', 'login.html');
                    }
                    this.onChange('loginText', function (inEvent, inText) {
                        var text = inText;
                        if (loginReady) {
                            text = inUser.get('userName');
                        }
                        return text;
                    }, this, {before: true});
                }, this);
            }, this);


            //加入购物车
            nb.model.onChange('headerGoAddCart', function (inEvent, inData) {
                var cartList = this.get('cartList');
                this.set('totalAmount', inData.amount);
                this.set('totalCount', inData.count);
                cartList.set('items', inData.items || []);
                this._showCartState();
            }, this);

            //总价
            this.onChange('totalAmount', function (inEvent, inAmount) {
                if (inAmount) {
                    return '￥' + inAmount.toFixed(2);
                }
            }, this, {before: true});

            var count;

            //个数
            this.onChange('totalCount', function (inEvent, inCount) {
                count = inCount;
                if (inCount > 99) {
                    count = 99 + '+';
                }
                this.set('totalAmountText', inCount);

                this.set('countVisible', inCount > 0 ? 'show' : '');
                this.set('totalCountTop', count);
            }, this);

            nb.model.onChange('changeLanguageReady', function (inEvent, inData) {
                if (inData == 'cn') {
                    this.set('totalAmountPrefix', '共');
                    this.set('totalAmountSuffix', '件商品，共计');
                } else {
                    this.set('totalAmountPrefix', '');
                    this.set('totalAmountSuffix', 'items&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;totals');
                }
            }, this);


            //刷新购物车
            nb.model.onChange('refreshHeadCart', function (inEvent, inData) {
                this._getCartList();
            }, this);
        },

        //购物车列表
        _getCartList: function () {
            var cartList = this.get('cartList');
            getCartList({
                data: {
                    type: 1,
                    userId: this._userId,
                    companyId: this._companyId
                },
                scope: this,
                success: function (inResp) {
                    this.set('totalAmount', inResp.amount);
                    this.set('totalCount', inResp.count);
                    cartList.set('items', inResp.items || []);
                }
            });
        },

        //显示购物车列表
        _showCartState: function () {
            var self = this;
            $('.item-cart').addClass('uk-open');
            setTimeout(function () {
                self._hiddenCartState();
            }, 3000);

        },

        //隐藏购物车列表
        _hiddenCartState: function () {
            $('.item-cart').removeClass('uk-open');
        },

        //销售信息
        _getSalesInfo: function (inOpts) {
            if (this._companyId) {
                getSalesInfo({
                    data: {
                        companyId: this._companyId
                    },
                    scope: this,
                    success: function (inResp) {
                        var salesName = inResp.name;
                        var salesPhone = inResp.phone ? inResp.phone : inResp.phone2;
                        var salesPhone2 = inResp.phone2;
                        var salesEmail = inResp.email;

                        this.setOpts({
                            salesName: salesName,
                            salesPhone: salesPhone,
                            salesEmail: salesEmail
                        })
                    }
                })
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/model/Header.js
// module id = 7
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39